<script>
import { required } from 'vuelidate/lib/validators'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Recommendations from './recommendations'

import axios from 'axios'

export default {
	page: {
		title: 'All Incidents',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: { Layout, PageHeader, Recommendations },
	data() {
		return {
			title: 'All Incidents',
			category: 'List',
			items: [
				{
					text: 'Home',
					href: '/',
				},
				{
					text: 'All Incidents',
					active: true,
				},
			],
		}
	},
	validations: {
		event: {
			title: { required },
			category: { required },
		},
	},
	methods: {

	},
	computed: {

	},
	mounted () {

	},
}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<Recommendations :url="'/pan/xdr/incidents?include=incident.incident,incident.assets'"/>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>
